import React, { useEffect } from 'react';
import { ErrorMessage, useFormikContext } from 'formik';
import TableFormField from '../../forms/fields/TableFormField';
import { matrixSanctionNames } from '../../API';
import { mapSelectValues } from '../../screens/SetupAndConfigurationScreens/DisciplinaryMatrix/DisciplinaryMatrixData';
import './CustomTransgressionsRow.scss';

interface CustomTransgressionsRowProps {
  index: number;
}

const CustomTransgressionsFAQRow: React.FC<CustomTransgressionsRowProps> = (props: CustomTransgressionsRowProps) => {
  const index = props.index;
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    // set default values for active and default properties of row item on init
    setFieldValue(`customTransgressions.${index}.active`, true);
    setFieldValue(`customTransgressions.${index}.default`, false);
  }, []);

  return (
    <>
      <td className="position-relative" style={{ fontSize: '1em', minWidth: '100px', maxWidth: '150px' }}>
        <TableFormField
          type={'textarea'}
          placeholder={'Enter Transgression'}
          name={`customTransgressions.${index}.transgression`}
          className="square-radius border-0 customTransgressionInput font-weight-bold text-muted"
          hideScrollerAndResize
          disabled
        />
        <span className="text-danger">
          <ErrorMessage className="text-danger" name={`customTransgressions.${index}.transgression`} />
        </span>
      </td>
      <td style={{ maxWidth: '100px' }}>
        <TableFormField
          type={'textarea'}
          placeholder={'Select Category'}
          name={`customTransgressions.${index}.transgressionCategory`}
          className="font-weight-bold customCategoryFont text-muted"
          hideScrollerAndResize
          disabled
        />
        <span className="text-danger">
          <ErrorMessage className="text-danger" name={`customTransgressions.${index}.transgressionCategory`} />
        </span>
      </td>
      <td className="position-relative" style={{ maxWidth: '120px' }}>
        <TableFormField
          type={'select'}
          placeholder={'Select Sanction'}
          name={`customTransgressions.${index}.sanction.firstOffence`}
          selectOptions={mapSelectValues(Object.keys(matrixSanctionNames))}
          className="square-radius border-1 px-0"
          disabled
        />
        <span className="text-danger">
          <ErrorMessage className="text-danger" name={`customTransgressions.${index}.sanction.firstOffence`} />
        </span>
      </td>
      <td className="position-relative" style={{ maxWidth: '120px' }}>
        <TableFormField
          type={'select'}
          placeholder={'Select Sanction'}
          name={`customTransgressions.${index}.sanction.secondOffence`}
          selectOptions={mapSelectValues(Object.keys(matrixSanctionNames))}
          className="square-radius border-1 px-0"
          disabled
        />
        <span className="text-danger">
          <ErrorMessage className="text-danger" name={`customTransgressions.${index}.sanction.secondOffence`} />
        </span>
      </td>
      <td className="position-relative" style={{ maxWidth: '120px' }}>
        <TableFormField
          type={'select'}
          placeholder={'Select Sanction'}
          name={`customTransgressions.${index}.sanction.thirdOffence`}
          selectOptions={mapSelectValues(Object.keys(matrixSanctionNames))}
          className="square-radius border-1 px-0"
          disabled
        />
        <span className="text-danger">
          <ErrorMessage className="text-danger" name={`customTransgressions.${index}.sanction.thirdOffence`} />
        </span>
      </td>
      <td className="position-relative" style={{ maxWidth: '120px' }}>
        <TableFormField
          type={'select'}
          placeholder={'Select Sanction'}
          name={`customTransgressions.${index}.sanction.fourthOffence`}
          selectOptions={mapSelectValues(Object.keys(matrixSanctionNames))}
          className="square-radius border-1 px-0"
          disabled
        />
        <span className="text-danger">
          <ErrorMessage className="text-danger" name={`customTransgressions.${index}.sanction.fourthOffence`} />
        </span>
      </td>
      <td className="position-relative" style={{ maxWidth: '120px' }}>
        <TableFormField
          type={'select'}
          placeholder={'Select Sanction'}
          name={`customTransgressions.${index}.sanction.fifthOffence`}
          selectOptions={mapSelectValues(Object.keys(matrixSanctionNames))}
          className="square-radius border-1 px-0"
          disabled
        />
      </td>
      <td className="position-relative" style={{ maxWidth: '120px' }}>
        <TableFormField
          type={'select'}
          placeholder={'Select Sanction'}
          name={`customTransgressions.${index}.sanction.sixthOffence`}
          selectOptions={mapSelectValues(Object.keys(matrixSanctionNames))}
          className="square-radius border-1 px-0"
          disabled
        />
      </td>
    </>
  );
};

export default CustomTransgressionsFAQRow;
